import { GetTransactionQueryType } from 'features/userTransactions/types';

export const getTransactionsUrlConfig = ({ user_id, app_type, page, size, search }: GetTransactionQueryType): string =>
  `/wallet/admin/${app_type}/transactions/bonus/${user_id}?page=${page}&size=${size}${
    search ? `&search=${search}` : ''
  }`;
